<div
  class="grid aspect-square min-w-10 place-items-center overflow-hidden rounded-full border border-white @container"
  [class.bg-white]="avatarUrl()"
  [class.bg-indigo-300]="!avatarUrl()"
>
  @if (avatarUrl()) {
    <!-- image -->
    <img
      [src]="avatarUrl()"
      alt="Avatar"
      class="h-full w-full object-cover object-center"
    />
  } @else if (isLoading()) {
    <!-- loading -->
    <ag1-loader />
  } @else {
    <!-- fallback -->
    <h3 class="text-[clamp(0.75rem,50cqw,3rem)] font-semibold uppercase">
      {{ initial() }}
    </h3>
  }
</div>
